module.exports = __webpack_public_path__ + "IcoEditCi.png";